import React from "react";
import { useSEO } from "@/lib/seo";
import { PageHero } from "@/components/PageBits";
import { useQuote } from "@/context/QuoteContext";
import { Button } from "@/components/ui/button";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "What is your MOQ?", a: "Our minimum order quantity starts at just 10 kg for most blends and 25 kg for hotel-grade powder. We offer flexible MOQ options depending on your business needs." },
  { q: "Can you customize blends?", a: "Yes. We create tailored blends and custom packaging to match your brand's taste profile and identity. Share your requirement and our blenders will craft a sample." },
  { q: "Do you supply across India?", a: "Absolutely. Leaf Alchemy dispatches bulk tea powder to hotels, restaurants, hospitals and distributors across India." },
  { q: "How quickly do you deliver?", a: "Most orders are dispatched within 2–4 business days, with final delivery timelines depending on your location and order size." },
  { q: "Can I become a distributor?", a: "Yes! We welcome distributor partnerships with attractive margins and exclusive territories. Visit our 'Become a Distributor' page to apply." },
  { q: "Do you offer free samples?", a: "Yes, we provide complimentary samples to serious business enquiries. Request one via our Free Sample page." },
  { q: "What certifications do you hold?", a: "Leaf Alchemy is FSSAI licensed and GST registered, with hygienic, food-grade manufacturing and packing." },
  { q: "What pack sizes are available?", a: "We offer retail packs (250g, 500g, 1kg) and bulk packs (5kg, 25kg and above) depending on the product." },
];

export default function FAQ() {
  useSEO({ title: "FAQ", description: "Frequently asked questions about Leaf Alchemy tea powder — MOQ, custom blends, delivery, distribution and certifications." });
  const { openQuote } = useQuote();

  return (
    <div data-testid="faq-page">
      <PageHero eyebrow="Help Center" title="Frequently Asked Questions"
        subtitle="Everything you need to know about ordering from Leaf Alchemy." />
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-forest/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-lg text-forest hover:text-gold hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="text-center mt-12">
            <p className="text-muted-foreground mb-4">Still have questions?</p>
            <Button onClick={() => openQuote({ type: "contact", title: "Ask a Question" })} className="rounded-full bg-forest hover:bg-olive text-cream px-8 transition-colors" data-testid="faq-cta">Contact Us</Button>
          </div>
        </div>
      </section>
    </div>
  );
}
